export enum PresentationError {
  ConnectionLost = 'CONNECTION_LOST',
  ConnectionLostTryAgain = 'CONNECTION_LOST_TRY_AGAIN',
  NoError = '' // no error
}



// WEBPACK FOOTER //
// ./src/constants/ErrorTypes.ts